import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const [searchText, setSearchText] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchText.trim()) {
      navigate(`/category/movie?q=${encodeURIComponent(searchText.trim())}`);
    }
  };

  return (
    <section className="relative w-full min-h-[550px] md:min-h-[650px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinema%20hall%20with%20red%20velvet%20curtains%20and%20warm%20golden%20stage%20lights%2C%20atmospheric%20movie%20theater%20interior%2C%20dramatic%20lighting%20with%20soft%20shadows%2C%20elegant%20classic%20cinema%20aesthetic%2C%20empty%20stage%20with%20spotlight%2C%20rich%20textures%2C%20high%20detail%20photography&width=1920&height=1080&seq=hero-bg-01&orientation=landscape"
          alt="蚂蚁影视 - 高清免费在线观影"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full site-container text-center py-12 md:py-16">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 leading-tight font-heading">
            高清免费在线观影
            <br />
            <span className="text-primary-400">不缓冲</span>，畅快追剧
          </h1>
          <p className="text-base md:text-lg text-background-200 mb-8 max-w-xl mx-auto leading-relaxed">
            海量电影、电视剧、综艺、动漫、纪录片资源，高清画质，秒开播放，随时随地享受影院级观影体验
          </p>

          <form onSubmit={handleSearch} className="flex items-center max-w-lg mx-auto bg-background-50 rounded-full p-1.5 shadow-lg">
            <div className="flex items-center gap-2 pl-4 flex-1">
              <i className="ri-search-line text-foreground-400 text-lg"></i>
              <input
                type="text"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                placeholder="搜索你想看的电影、电视剧..."
                className="flex-1 bg-transparent border-none outline-none text-foreground-900 text-sm py-2.5 placeholder:text-foreground-400"
              />
            </div>
            <button
              type="submit"
              className="px-6 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              搜索
            </button>
          </form>

          <div className="flex items-center justify-center gap-3 mt-6 flex-wrap">
            <span className="text-background-300 text-xs">热门搜索：</span>
            {['流浪地球3', '庆余年', '鬼灭之刃', '封神', '哪吒'].map((tag) => (
              <button
                key={tag}
                onClick={() => {
                  setSearchText(tag);
                }}
                className="px-3 py-1 rounded-full bg-background-50/15 text-background-200 text-xs hover:bg-background-50/25 transition-all duration-200 border border-background-50/20 whitespace-nowrap cursor-pointer"
              >
                {tag}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-3 md:grid-cols-3 gap-4 md:gap-6 max-w-2xl mx-auto">
          {[
            { icon: 'ri-movie-2-line', label: '海量片源', desc: '10万+影视资源' },
            { icon: 'ri-4k-line', label: '超清画质', desc: '支持4K播放' },
            { icon: 'ri-speed-line', label: '极速流畅', desc: 'CDN全球加速' },
          ].map((item) => (
            <div key={item.label} className="text-center p-3 md:p-4 rounded-xl bg-background-50/10 backdrop-blur-sm border border-background-50/15">
              <div className="w-10 h-10 md:w-12 md:h-12 mx-auto flex items-center justify-center rounded-full bg-primary-500/20 mb-2 md:mb-3">
                <i className={`${item.icon} text-primary-400 text-lg md:text-xl`}></i>
              </div>
              <p className="text-background-50 text-sm md:text-base font-medium font-heading">{item.label}</p>
              <p className="text-background-400 text-xs mt-0.5">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}